import store from '@/store';
import { getRoleById } from '@/enums/roles';
import { isValidDomain } from '@/helpers/urlHelpers';
import config from '@/config'; // eslint-disable-line import/extensions
import { isUserAllowedRoute } from './PermissionMiddleware';
import { publicRoutes } from '../publicRoutes';

const AuthMiddleware = async (to, from, next) => {
  const { isAuth } = store.state.auth;
  if (isAuth) {
    try { await store.dispatch('auth/getCurrentUser'); } catch (error) { next(false); return; }
  }
  const { currentUser } = store.state.auth;
  document.title = `${to.meta.name}${to.meta.name.length ? ' - ' : ''}Hart Estate`;
  const isPublicByName = publicRoutes.some(({ name }) => to.name === name);
  const isPublicByPathPrefix = publicRoutes.some(({ pathname }) => pathname && to.path.startsWith(pathname));

  if (to.path === '/auth') {
    if (isAuth) {
      const { returnUrl } = to.query;
      const currentRole = getRoleById(currentUser.roles[0]?.id);

      if (returnUrl && isValidDomain(returnUrl, config.baseDomain)) {
        try {
          await store.dispatch('auth/refreshCookie');
          window.location.href = returnUrl;
          return;
        } catch (error) {
          console.error('Failed to refresh authentication cookie:', error);
        }
      }

      next(currentRole?.startPage ?? '/access_denied');
      return;
    }
    next();
    return;
  }

  if (isPublicByName || isPublicByPathPrefix) {
    next();
    return;
  }

  if (!isAuth && to.path !== '/auth') {
    next(`/auth?targetPage=${to.path}`);
    return;
  }

  if (to.meta.permission && !isUserAllowedRoute(currentUser, to.meta)) {
    next('/access_denied');
    return;
  }

  next();
};

export { AuthMiddleware };
